import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";

export default function installValidationRules()
{
    extend('required', {
        ...required,
        message: 'Questo campo è richiesto'
    });
}
